import { render, staticRenderFns } from "./ProposalsPage.vue?vue&type=template&id=6ce02a1d&scoped=true"
import script from "./ProposalsPage.vue?vue&type=script&lang=js"
export * from "./ProposalsPage.vue?vue&type=script&lang=js"
import style0 from "./ProposalsPage.vue?vue&type=style&index=0&id=6ce02a1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce02a1d",
  null
  
)

export default component.exports